import React from 'react';
import OnlyUIRender from '../OnlyUIRender/index.js';
import ModalContent from './ModalContent/index.js';
import 'react-dom';
import '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import 'next-i18next';
import '../../context/index.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import '../../index-RkBJ48Nr.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../hooks/useAutoFocus.js';
import '../../index-tjIjLI8L.js';
import 'i18next';
import 'react-i18next';
import '../../index-EglyFAWQ.js';
import 'next/router';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import 'notistack';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../cookies-l-jEMp6P.js';
import 'lodash';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import './ModalHeader/index.js';

const Modal = (props) => {
    const { children } = props;
    return (
    // Using OnlyUIRender wrapper
    // To deny a render of the Modal component on SSR
    // because there is no access to a "document" and "window" objects
    React.createElement(OnlyUIRender, null,
        React.createElement(ModalContent, { ...props }, children)));
};

export { Modal as default };
//# sourceMappingURL=index.js.map
